import { Select } from 'client/components/core/Sidebar/components/Settings/components'
import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities/index'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import React from 'react'
import { usePreserveEntityFieldsAcrossDiscriminator } from 'src/editor/hooks/use-preserve-fields-across-discriminator/use-preserve-entity-fields-across-discriminator'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { ShowPopupActionButtonEntityInterface } from 'src/shared/entities/button/show-popup.action-button.schema'
import { ShowPopupWebsiteActionButtonEntityInterface } from 'src/shared/entities/website-button/show-popup-website-button.schema'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'

type CommonShowPopupActionButtonEntityInterface =
  | ShowPopupActionButtonEntityInterface
  | ShowPopupWebsiteActionButtonEntityInterface

export const ButtonShowPopupActionSettings = ({
  entity,
}: SettingsProps<
  ActionButtonEntityInterface | WebsiteButtonEntityInterface
>) => {
  const updateProp = useUpdateProp(
    entity as CommonShowPopupActionButtonEntityInterface,
  )
  const popups = usePage(pageSelectors.getWebsiteGlobalOrPagePopupEntities)(
    entity,
  )

  usePreserveEntityFieldsAcrossDiscriminator({
    entity: entity as CommonShowPopupActionButtonEntityInterface,
    discriminator: [{ key: 'action', value: ButtonActionTypeEnum.ShowPopup }],
    preservedKeys: ['popup'],
  })

  const popupChoiceList = popups.reduce(
    (popupChoices, popup) => {
      popupChoices[popup.id] =
        popup.type === EntityTypeEnum.Popup
          ? popup?.title
          : popup?.options?.title
      return popupChoices
    },
    {} as Record<string, string>,
  )

  return entity.action === ButtonActionTypeEnum.ShowPopup ? (
    <Select
      labelText="Popup"
      update={updateProp('popup')}
      choiceList={popupChoiceList}
      firstOption="entity_settings.button.choose_actions"
      value={entity.popup}
      skipTranslation
    />
  ) : null
}
